import { render, staticRenderFns } from "./SupplierRiskTab2.vue?vue&type=template&id=1e8275cb&"
import script from "./SupplierRiskTab2.vue?vue&type=script&lang=js&"
export * from "./SupplierRiskTab2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports